import Leasing from './views/leasing.c';

export default Leasing;
